
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M8 6c.264 0 .519.105.706.293l4.707 4.706 3.59.001V9a.501.501 0 01.851-.36l3.002 3a.51.51 0 010 .71l-3.002 3a.5.5 0 01-.85-.35v-2L17 12.999V13h-3.586l-4.708 4.707A.995.995 0 018 18H3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4.084l4-4-4-4H3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H8z"}})])
          )
        }
      }
    